import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './card.module.css'

const propTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string
}

/**
 * Render card buttons.
 *
 * @param {ReactElement} [props.children] - The jsx children to be rendered
 * @param {string} [props.className] - Optional classname for the split container
 * @returns {ReactElement}
 */
export function CardSplitContainer(props) {
    const { children, className } = props

    return <div className={cx(styles['card-split-container'], 't3sel-card-split-container', className)}>{children}</div>
}

CardSplitContainer.propTypes = propTypes
